(() => {
  const install = (root) => {
    if (root.dataset.manualGuard) return;
    root.dataset.manualGuard = 'true';
    const panel = root.querySelector('.pp-assistant-panel');
    const launcher = root.querySelector('.pp-assistant-launcher');
    if (!panel || !launcher) return;
    const close = () => {
      panel.removeAttribute('data-manual-open');
      panel.hidden = true;
      launcher.setAttribute('aria-expanded', 'false');
    };
    close();
    root.addEventListener('click', (event) => {
      if (event.target.closest('.pp-assistant-launcher')) {
        if (panel.hasAttribute('data-manual-open')) panel.removeAttribute('data-manual-open');
        else { panel.hidden = true; panel.setAttribute('data-manual-open', ''); }
      } else if (event.target.closest('.pp-assistant-close')) close();
    }, true);
    root.addEventListener('keydown', (event) => { if (event.key === 'Escape') close(); });
    new MutationObserver(() => {
      if (!panel.hasAttribute('data-manual-open') && !panel.hidden) close();
    }).observe(panel, { attributes: true, attributeFilter: ['hidden'] });
  };
  const scan = () => document.querySelectorAll('[data-plakperso-assistant]').forEach(install);
  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
  scan();
})();
